export const state = {
  getProjectsFoldersTreePending: false,
  projectsFoldersTree: [],
  projectsFolderByIdPending: false,
  currentProjectsFolder: {},
  roomToMove: {},
  moveRoomDialogIsOpen: false,
  moveRoomPending: false,
}
